/**
 * The product brand name — the single source of truth for every user-facing
 * surface (page <title>, auth screens, sidebar wordmark, email subjects/bodies,
 * PDF headers, seeded help content). Never hardcode the brand name anywhere;
 * import APP_NAME from here so a rebrand is one edit.
 *
 * Internal identifiers are intentionally NOT derived from this (the `--ikroot-*`
 * CSS token prefix, the `financial-os` package name, DB/table names) — those are
 * implementation details, not brand.
 */
export const APP_NAME = "iKroot";
